import React from 'react'
import moment from 'moment'

import { styled, s } from 'lib/styled'

import { ReactComponent as ClockIcon } from 'assets/clock.svg'
import { ReactComponent as WindIcon } from 'assets/wind.svg'
import { ReactComponent as FlagIcon } from 'assets/flag.svg'

const Root = styled.div(s('p-2'), {
  minWidth: '120px',
})

const Text = styled.span(s('text-base text-white'))

// Some icons need to be made larger or smaller to get them to a similar size.
// This results in inconsistent spacing between icons and text, so we just need to wrap
// the icons to ensure that they have a consistent size.`
const ConsistentSize = styled.div(s('flex items-center justify-center'), {
  width: 24,
  height: 24,
})

const FlexRow = styled.div({
  '& + &': s('mt-1'),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})

function TooltipContents({ assessment }) {
  const { assessmentValidityPeriodStart, assessmentValidityPeriodEnd } = assessment

  const { windSpeed: speed, windDirection: direction } = assessment.algorithmInputs
  const formattedSpeed = (Math.round(speed * 100) / 100).toFixed(2)

  const startTime = moment(assessmentValidityPeriodStart).format('ddd H:mm')
  const endTime = moment(assessmentValidityPeriodEnd).format('H:mm')

  return (
    <Root>
      <FlexRow>
        <ConsistentSize style={s('mr-1')}>
          <ClockIcon width={18} height={18} fill="white" />
        </ConsistentSize>

        <Text>
          {startTime} - {endTime}
        </Text>
      </FlexRow>

      <FlexRow>
        <ConsistentSize style={s('mr-1')}>
          <WindIcon width={21} height={21} fill="white" />
        </ConsistentSize>

        <Text>{formattedSpeed} kt</Text>

        <ConsistentSize style={s('ml-2')}>
          <FlagIcon width={14} height={14} fill="white" />
        </ConsistentSize>

        <Text style={s('text-sm tracking-wide uppercase')}>{direction}</Text>
      </FlexRow>
    </Root>
  )
}

export { TooltipContents }
